import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './FarecardConvert.css';
import { Farecard } from '../../services/types/apitypes';

type FarecardConvertProps = {
  goBack: () => void;
  convert: (f: Farecard) => void;
  card: Farecard;
};

export default function FarecardConvert({
  goBack,
  card,
  convert,
}: FarecardConvertProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center">
        <IonIcon
          className="farcards-convert-circle"
          src="assets/icon/card-convert-circle.svg"
        ></IonIcon>
      </div>

      <h1 className="h1 pt-2 ion-text-center">{t('farecards.convert')}</h1>
      <p className="pt-1 instructions ion-text-center">
        {t('farecards.convertinstruction')}
      </p>

      <div className="pt-5 ion-text-center">
        <IonButton
          className="btn-default "
          expand="block"
          onClick={() => convert(card)}
        >
          {t('farecards.convertbutton')}
        </IonButton>
      </div>
      <div className="ion-text-center">
        <IonButton
          onClick={goBack}
          fill="outline"
          expand="block"
          className="btn-default"
        >
          {t('home.cancel')}
        </IonButton>
      </div>
    </>
  );
}
